import { useEffect } from 'react';
// redux
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
import { obtenerAyudantiasModulo } from '../../store/slices/ayudantia/thunks';
import { obtenerBloquesModulo, startLoadingBloque } from '../../store/slices/bloque';
import { obtenerEjerciciosModulo, startLoadingEjercicio } from '../../store/slices/ejercicio';
import { obtenerSeccionesModulo, startLoadingSeccion } from '../../store/slices/seccion';
import { startLoadingAyudantia } from '../../store/slices/ayudantia';
// LaTeX
import Latex from 'react-latex-next';
// mui components
import { styled } from '@mui/system';
import TabsUnstyled from '@mui/base/TabsUnstyled';
import TabsListUnstyled from '@mui/base/TabsListUnstyled';
import TabPanelUnstyled from '@mui/base/TabPanelUnstyled';
import { buttonUnstyledClasses } from '@mui/base/ButtonUnstyled';
import TabUnstyled, { tabUnstyledClasses } from '@mui/base/TabUnstyled';
import { Box } from '@mui/material';
// componentes propios
import BloquesEdicion from '../Bloques/BloquesEdicion';
import AyudantiasEdicion from '../Ayudantias/AyudantiasEdicion';
import EjerciciosEdicion from '../Ejercicios/EjerciciosEdicion';

const blue = {
    50: '#F0F7FF',
    200: '#80BFFF',
    400: 'rgb(255, 255, 255, 0.2)',
    500: 'rgb(24, 62, 138, 0.9)',
    600: 'rgb(24, 62, 138, 1)',
};

const Tab = styled(TabUnstyled)`
    font-family: IBM Plex Sans, sans-serif;
    color: white;
    cursor: pointer;
    font-size: 0.875rem;
    font-weight: bold;
    background-color: transparent;
    // width: 100%;
    width: 120px;
    padding: 12px 16px;
    margin: 6px 6px;
    border: none;
    border-radius: 5px;
    display: flex;
    justify-content: center;

    &:hover {
        background-color: ${blue[400]};
    }

    &:focus {
        color: #fff;
        border-radius: 3px;
        outline: 2px solid ${blue[200]};
        outline-offset: 2px;
    }

    &.${tabUnstyledClasses.selected} {
        background-color: ${blue[50]};
        color: ${blue[600]};
    }

    &.${buttonUnstyledClasses.disabled} {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

const TabPanel = styled(TabPanelUnstyled)`
    width: 100%;
    font-family: IBM Plex Sans, sans-serif;
    margin-top: 2em;
    // font-size: 0.875rem;
`;

const TabsTitle = styled(TabsListUnstyled)`
    min-width: 320px;
    height: 50px; 
    background-color: ${blue[500]};
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    padding-top: 1em;
    padding-left: 1.5em;
    padding-right: 1.5em;
    display: flex;
    align-items: center;
    // justify-content: center;
    align-content: space-between;
`;
  
const TabsList = styled(TabsListUnstyled)`
    min-width: 320px;
    height: 60px; 
    background-color: ${blue[500]};
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    padding-left: 1em;
    padding-right: 1em;
    padding-bottom: 1em;
    display: flex;
    align-items: center;
    // justify-content: center;
    align-content: space-between;
`;

const ModuloEdicion = () => {

    const dispatch = useDispatch<AppDispatch>();

    const { modulo } = useSelector((state: RootState) => state.modulo);

    useEffect(() => {
        const { mid } = modulo;
        dispatch(startLoadingBloque())
        dispatch(obtenerBloquesModulo(mid));

        dispatch(startLoadingSeccion());
        dispatch(obtenerSeccionesModulo(mid));

        dispatch(startLoadingEjercicio())
        dispatch(obtenerEjerciciosModulo(mid));

        dispatch(startLoadingAyudantia())
        dispatch(obtenerAyudantiasModulo(mid));
    }, [modulo, dispatch]);

    return (
        <TabsUnstyled defaultValue={0}>
            <TabsTitle>
                <Box sx={{color: 'white'}}>
                    <h5><Latex>{modulo?.nombre}</Latex></h5>
                </Box>
            </TabsTitle>
            <TabsList>
                <Tab>Clases</Tab>
                <Tab>Ayudantías</Tab>
                <Tab>Ejercicios</Tab>
            </TabsList>

            <TabPanel value={0}>
                <BloquesEdicion />
            </TabPanel>
            <TabPanel value={1}>
                <AyudantiasEdicion />
            </TabPanel>
            <TabPanel value={2}>
                <EjerciciosEdicion />
            </TabPanel>
        </TabsUnstyled>
    )
}

export default ModuloEdicion;